import React, {memo} from "react";
import {IPageContainerState} from "@montana/containers/page";
import {IStaticProductPage} from "@montana/models/generated/cms.interface";
import cx from "clsx";
import {Container} from "@montana/shared/container";
import {HeroStaticProductModule} from "@montana/pages/static-product-page/hero/static-product-page-hero.component";
import {DynamicBlocks} from "@montana/blocks/dynamic-blocks.component";

export const StaticProductPage = memo((props: IPageContainerState & IStaticProductPage) => {
    const {blocks} = props;
    return (
        <Container>
            <div className={cx('app__block', 'app__block--break-container', 'app__block--m01-hero-block')}>
                <HeroStaticProductModule {...props} />
            </div>
            <DynamicBlocks blocks={blocks}/>
        </Container>
    )
})

StaticProductPage.displayName = "StaticProductPage";